module.exports = __webpack_public_path__ + "static/media/Cami.fd9dd020.png";